import { useCallback, useMemo } from 'react';

import { useEligibleServicesStore } from '../stores';

export const useServiceActions = () => {
  const { state, setState } = useEligibleServicesStore();
  const eligibleServicesIdsArray = useMemo(() => state?.eligibleServicesIds || [], [state]);

  const handleServiceSelect = useCallback((id: string) => {
    const newEligibleServicesIds = eligibleServicesIdsArray?.includes(id)
      ? eligibleServicesIdsArray?.filter((itemId) => itemId !== id)
      : eligibleServicesIdsArray ? [...eligibleServicesIdsArray, id] : [id];

    setState({
      eligibleServicesIds: newEligibleServicesIds,
    });
  }, [eligibleServicesIdsArray, setState]);

  return {
    eligibleServicesIdsArray,
    handleServiceSelect,
  };
};
